import { getMessageFromError } from '../utils/functions'

const PREFIX = 'admin/leadership'

export default {
  async create({ commit }, data) {
    commit('SET_STATE', { action: 'createLoading', data: true })
    try {
      const res = await this.$http.post(`${PREFIX}/create`, data)
      commit('SET_STATE', { action: 'createLoading', data: false })
      return { message: res.data.message }
    } catch (error) {
      commit('SET_STATE', { action: 'createLoading', data: false })
      const { message } = getMessageFromError(error)
      return Promise.reject({ message })
    }
  },

  async get({ commit }, params) {
    commit('SET_STATE', { action: 'listLoading', data: true })
    try {
      const query = { ...params }
      if (Array.isArray(query.order) && query.order.length === 2) {
        query.sort_by = `${query.order[0]}:${String(query.order[1]).toLowerCase()}`
        delete query.order
      }
      const res = await this.$http.get(`${PREFIX}/list`, { params: query })
      commit('SET_STATE', { action: 'listLoading', data: false })
      commit('SET_STATE', { action: 'records', data: res.data.data.results })
      commit('SET_STATE', { action: 'total', data: res.data.data.totalResults })
      commit('SET_STATE', { action: 'FilteredCount', data: res.data.data.totalResults })
    } catch (error) {
      commit('SET_STATE', { action: 'listLoading', data: false })
      const { message } = getMessageFromError(error)
      return Promise.reject({ message })
    }
  },

  async delete({ commit }, id) {
    commit('SET_STATE', { action: 'listLoading', data: true })
    try {
      const res = await this.$http.delete(`/${PREFIX}/delete/${id}`)
      commit('SET_STATE', { action: 'listLoading', data: false })
      return { data: res.data, message: res.data.message }
    } catch (error) {
      commit('SET_STATE', { action: 'listLoading', data: false })
      const { message } = getMessageFromError(error)
      return Promise.reject({ message })
    }
  },

  async update({ commit }, { id, data }) {
    commit('SET_STATE', { action: 'createLoading', data: true })
    try {
      const res = await this.$http.put(`${PREFIX}/update/${id}`, data)
      commit('SET_STATE', { action: 'createLoading', data: false })
      return { data: res.data.data, message: res.data.message }
    } catch (error) {
      commit('SET_STATE', { action: 'createLoading', data: false })
      const { message } = getMessageFromError(error)
      return Promise.reject({ message })
    }
  },

  async show({ commit }, id) {
    commit('SET_STATE', { action: 'listLoading', data: true })
    try {
      const res = await this.$http.get(`${PREFIX}/details/${id}`)
      commit('SET_STATE', { action: 'listLoading', data: false })
      commit('SET_STATE', { action: 'record', data: res.data.data })
      return { data: res.data, message: res.data.message }
    } catch (error) {
      commit('SET_STATE', { action: 'listLoading', data: false })
      const { message } = getMessageFromError(error)
      return Promise.reject({ message })
    }
  },

  async updateStatus({ commit }, { id, status }) {
    commit('SET_STATE', { action: 'loading', data: true })
    try {
      const res = await this.$http.put(`${PREFIX}/manage-status/${id}`, status)
      commit('SET_STATE', { action: 'loading', data: false })
      return { data: res.data.data, message: res.data.message }
    } catch (error) {
      commit('SET_STATE', { action: 'loading', data: false })
      const { message } = getMessageFromError(error)
      return Promise.reject({ message })
    }
  }
}
